<template>
    <div>
        <pencilbutton @click="startUpdate()" v-if="showEcomTypeAdmin"/>
        <!-- PRODUCT TYPE ECOMMERCE FLAGS MODAL -->
        <actionmodal ref="mymodal">
            <template v-slot:body>
                <form ref="myform">
                    <label class="titlelabel">Ecommerce Flags — {{ProductType.name}}</label>

                    <div class="entry">
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="showonlinetypefield">Show Online</label>
                        </div>
                        <div class="entryTextDiv">
                            <input id="showonlinetypefield" class="entryCheckbox" type="checkbox" v-model="ProductType.showOnline">
                        </div>
                    </div>

                    <formentry inputid="nameonlinetypefield" label="Name Online" v-model="ProductType.nameOnline"/>

                    <div class="entry">
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="isfoodfield">Is Food</label>
                        </div>
                        <div class="entryTextDiv">
                            <input id="isfoodfield" class="entryCheckbox" type="checkbox" v-model="ProductType.isFood">
                        </div>
                    </div>

                    <div class="entry">
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="showforarfield">Show For AR</label>
                        </div>
                        <div class="entryTextDiv">
                            <input id="showforarfield" class="entryCheckbox" type="checkbox" v-model="ProductType.showForAR">
                        </div>
                    </div>

                    <div class="entry">
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="showfornonarfield">Show For Non-AR</label>
                        </div>
                        <div class="entryTextDiv">
                            <input id="showfornonarfield" class="entryCheckbox" type="checkbox" v-model="ProductType.showForNonAR">
                        </div>
                    </div>

                    <div class="entry" v-if="locationId > 0">
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="isactivetypefield">Active at this Location</label>
                        </div>
                        <div class="entryTextDiv">
                            <input id="isactivetypefield" class="entryCheckbox" type="checkbox" v-model="ProductType.isActive">
                        </div>
                    </div>

                    <smallbutton @click="saveType()" toplabel="Save" buttonclass="button buttonsave"/>
                    <smallbutton @click="cancelupdate()" toplabel="Cancel" buttonclass="button buttoncancel"/>
                    <div>
                        <label class="responsemessage">{{message}}</label>
                    </div>
                </form>
            </template>
        </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../services/datamethods.js'
import smallbutton from '../controls/button.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
import pencilbutton from '../controls/pencilbutton.vue'
export default {
    name:'updateProductType',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        pencilbutton
    },
    props:{
        inProductType:{
            type:Object,
            required:true
        },
        locationId:{
            type:Number,
            default:0
        }
    },
    mixins:[datamethods],
    data(){
        return{
            message:'',
            ProductType:{}
        }
    },
    computed:{
        showEcomTypeAdmin(){
            return !!window.ECOM_TYPE_ADMIN
        }
    },
    methods:{
        startUpdate(){
            // clone so cancel discards edits
            this.ProductType = JSON.parse(JSON.stringify(this.inProductType))
            this.message=''
            this.$refs.mymodal.openModal()
        },
        cancelupdate(){
            this.$refs.mymodal.closeModal()
        },
        async saveType(){
            this.$store.dispatch('beforeAPI')
            var response = await this.callAPI(this.ProductType,'ecommerce/admin/updateproducttypeecommerce')
            if(!response.Successful){
                this.message = response.Message
                return
            }
            // per-location activation is a separate SP call
            if(this.locationId > 0){
                let activeReq = {
                    salonId:this.locationId,
                    productTypeId:this.ProductType.id,
                    isActive:this.ProductType.isActive
                }
                await this.callAPI(activeReq,'ecommerce/admin/updatesalonproducttypeactive')
            }
            this.$refs.mymodal.closeModal()
            this.$emit('refresh')
        }
    }
}
</script>
